import moment from "moment"

export const getFormattedLocalizedDate = (date,configuration) => {
	if(date){
		const dateAsMoment = moment(date);
		const monthsAsString = (configuration ? configuration.months : null) || "";
		const monthsAsArray = monthsAsString.replace(/\s/g, '').split(',');

		let dateOfMonth = dateAsMoment.format("D");
		let month = dateAsMoment.format("MMM");
		if(monthsAsArray.length === 12){
			month = monthsAsArray[dateAsMoment.month()]
		}
		let year = dateAsMoment.format("YYYY");

		return `${dateOfMonth} ${month} ${year}`;
	}
	return null;
}